const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

const jumper = () => {
    // private variable cache
    // no variables are created during a jump, preventing memory leaks

    let container; // element to scroll

    let start; // where scroll starts

    let easing = easeInOutQuad;

    let distance; // distance of scroll
    let duration = 1000; // scroll duration
    let scrolling; // scrolling state

    let timeStart; // time scroll started
    let timeElapsed; // time spent scrolling thus far

    let next; // next scroll position

    // rAF loop helper

    function loop(timeCurrent) {
        // store time scroll started, if not started already
        if (!timeStart) {
            timeStart = timeCurrent;
        }

        // determine time spent scrolling so far
        timeElapsed = timeCurrent - timeStart;

        // calculate next scroll position
        next = easing(timeElapsed, start, distance, duration);

        // scroll to it
        container.scrollLeft = next;

        // check progress
        timeElapsed < duration
            ? window.requestAnimationFrame(loop) // continue scroll loop
            : done(); // scrolling is done
    }

    // scroll finished helper

    function done() {
        scrolling = false;

        // account for rAF time rounding inaccuracies
        container.scrollLeft = start + distance;

        // reset time for next jump
        timeStart = false;
    }

    // API

    function jump(el, target) {
        if (scrolling) {
            return;
        }
        scrolling = true;
        // resolve options, or use defaults

        container = el;

        // cache starting position
        start = container.scrollLeft;

        // resolve scroll distance,
        distance = target - start;

        // start the loop
        window.requestAnimationFrame(loop);
    }

    // expose only the jump method
    return jump;
};

// export singleton

const singleton = jumper();

export default singleton;
